import type { FC } from 'react';
import { lazy } from 'react';
import { useCognitoUser } from 'src/hooks/use-cognito-user';
import { useDirectFcfsFlags } from 'src/hooks/use-direct-fcfs-flags';
import { TsoUserProvider } from 'src/pages/direct-fcfs/use-tso-user-context';
import { Forbidden, Unauthorized } from 'src/utils/errors';

const Page = lazy(() => import('./page'));

export const ManageDirectFcfs: FC = () => {
  const directFcfsFlags = useDirectFcfsFlags();

  // handle 401 manually since it would be reported as 403 otherwise
  const user = useCognitoUser();
  if (!user) throw new Unauthorized();

  if (
    !directFcfsFlags.data?.organisationId ||
    !(
      directFcfsFlags.data._links?.['view-requests'] ||
      directFcfsFlags.data._links?.['read-product'] ||
      directFcfsFlags.data._links?.['read-capacity']
    )
  )
    throw directFcfsFlags.error || new Forbidden();

  return (
    <TsoUserProvider
      value={{ organisationId: directFcfsFlags.data.organisationId }}
    >
      <Page directFcfsFlags={directFcfsFlags} />
    </TsoUserProvider>
  );
};
